import React from 'react';
import { ReactComponent as VideoDirSvg } from '../../../assets/svgs/videodir.svg';
import { ReactComponent as DeleteSvg } from '../../../assets/svgs/delete.svg';
import SvgCom from '../../../components/SvgCom/index.jsx';
import { checkShowMigrate, cn } from '../../../utils/utils';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { deleteProject, migrateToCT } from '../../../api/request.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, message, Modal } from 'antd';

const ProjectCardCom = ({ className ='', detailInfo, fnRefresh = () => {} }) => {
  const nvigate = useNavigate();
  const { title, status, created_at, id, response_count  } = detailInfo;

  const fnDelete = (e) => {
    e.stopPropagation();
    Modal.confirm({
      title: 'Warning',
      icon: <ExclamationCircleOutlined />,
      content: 'Do you want to delete this record?',
      okText: 'Entry',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await deleteProject({
            id: detailInfo.id
          });
          fnRefresh();
        } catch(error) {
          //
        } finally {
          //
        }
      }
    });
  };

  const fnMigrateToCT = async (e, id) => {
    e.stopPropagation();
    try {
      await migrateToCT({
        project_id: id
      });
      message.success('Migration success');
    } catch(error) {
      console.log(error);
    }
  };

  return (
    <div className={cn('bg-grey-1 rounded-xl p-[15px]', className)} onClick={() => nvigate(`/consumer-theatre-processing/project/detail/${id}`)}>
      <div className="flex items-center justify-between mb-[15px]">
        <span className="text-lg font-semibold leading-none">{title}</span>
        <div className="py-[8px] px-[16px] text-xs leading-none rounded-xl bg-primary text-white font-bold">{status}</div>
      </div>
      <div className="flex justify-start items-center text-sm leading-none text-grey-3 mb-[15px]">
        <span>Project ID</span>
        <span className="text-black ml-2 flex-1 text-right">{id}</span>
        <div className="h-5 w-[1px] mx-4 bg-[#D9D9D9]"></div>
        <span className="">{moment(created_at).format('ddd, MMM DD, YYYY')}</span>
      </div>
      <div className='flex items-center justify-between'>
        <div className="py-[10px] px-[15px] text-xs leading-none rounded-2xl bg-second flex items-center w-fit min-w-[120px]">
          <SvgCom Svg={VideoDirSvg} size="14"></SvgCom>
          <span className="text-primary mx-2">Video</span>
          <span className="font-bold text-black">{response_count}</span>
        </div>
        <div className='flex'>
          {
            checkShowMigrate(detailInfo.id) && <Button size='small' className='mr-2 text-primary' onClick={(e) => fnMigrateToCT(e, detailInfo.id)}>Migrate To CT</Button>
          }
          <SvgCom onClick={fnDelete} Svg={DeleteSvg} size="20" className="ml-2 cursor-pointer hover:text-green-1 text-primary"></SvgCom>
        </div>
      </div>
    </div>
  );
};

export default ProjectCardCom;